import React, { useState } from 'react';
import { Button, DialogActions, DialogContent, Grid, TextField } from '@material-ui/core';

export function SelectQuantity({ onDone, defaultValue = 1 }) {
    const [quantity, setQuantity] = useState(defaultValue);

    const handleDone = () => {
        onDone(quantity);
    };

    return (
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        label="Quantity"
                        type="number"
                        value={quantity}
                        onChange={e => {
                            const value = Number(e.target.value);
                            if (value > 0 && value <= 20) {
                                setQuantity(value);
                            }
                        }}
                        InputProps={{
                            inputProps: {
                                max: 20,
                                min: 1
                            }
                        }}
                        fullWidth
                    />
                </Grid>
            </Grid>
            <DialogActions>
                <Button onClick={handleDone} color="primary">
                    Done
                </Button>
            </DialogActions>
        </DialogContent>
    );
}
